<template>
  <RevStickyBar
    class="block md:hidden [@media(max-height:512px)]:hidden"
    :visible="showBar"
  >
    <div class="flex items-center">
      <div class="min-w-0 grow">
        <Price
          :flash-sales-discount
          :mobile-plan="selectedMobilePlan"
          :price
          :price-due-today="priceWithoutSubsidies"
          :product
          :selected-offer
        />
      </div>
      <RevButton
        class="ml-12 grow"
        data-qa="product-page-buy-button-sticky-bar"
        variant="primary"
        @click="onAddToCart"
      >
        {{ i18n(translations.addToCart) }}
      </RevButton>
    </div>
  </RevStickyBar>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Price as PriceType } from '@backmarket/http-api'
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-b2c-services/mobile-plan/types/mobile-plan-offers'
import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevStickyBar } from '@ds/components/StickyBar'

import { useAddToCart } from '~/scopes/product-core/components/containers/ContainerAddToCart/composables/useAddToCart/useAddToCart'
import Price from '~/scopes/product-core/components/presentationals/Price/Price.vue'
import { useProductTracking } from '~/scopes/product-core/composables/useProductTracking/useProductTracking'

import translations from './StickyBarBottom.translations'

const i18n = useI18n()

const props = withDefaults(
  defineProps<{
    selectedOffer: NonNullable<GetPickersResponse['selectedOffer']>
    price: PriceType
    product: GetProductResponse
    selectedMobilePlan?: MobilePlanOffer
    tracking: ReturnType<typeof useProductTracking>
    priceWithoutSubsidies?: PriceType | null
    showBar?: boolean
  }>(),
  {
    selectedMobilePlan: undefined,
    priceWithoutSubsidies: null,
    showBar: false,
  },
)

const { addToCart } = useAddToCart()

const flashSalesDiscount = computed(
  () =>
    props.product.promoCodes.find((promoCode) => promoCode.isFlashSale)
      ?.discountValue,
)

function onAddToCart() {
  addToCart({
    listingId: props.selectedOffer.offerLegacyId,
    listingPublicId: props.selectedOffer.offerId,
    tracking: {
      ...props.tracking.product.value,
      list: 'header',
      campaign_id: props.selectedOffer.campaignId,
      population_id: props.selectedOffer.populationId,
    },
    partnerPromoCodes: props.product.includedServiceOffers.partnerPromoCodes,
    isTradeInEligible: props.product.isTradeInEligible,
    promoCodes: props.product.promoCodes,
  })
}
</script>
